



































import { Component, Vue, Prop } from 'vue-property-decorator'
import PhotoHeader from '../components/organization/PhotoHeader.vue'
import Main from '../components/organization/Main.vue'
import MiniCourse from '../components/miniCourse/index.vue'
import SectionCourse from '../components/organization/SectionCourse.vue'


import { Palestras_Cursos } from '@/storage/programacao/palestras_new'
import Programacao from './Programacao.vue'

@Component({
  components: {
    PhotoHeader,
    Main,
    MiniCourse
  }
})
export default class Palestras extends Vue {
  private all_palestras
  private filtered_palestras

  private title = 'Palestras'
  private description = 'Palestras da jornada'
  private background = 'assets/img/slider/6.jpg'

  filterPalestras(e) {
    let data = e.target.innerText
    this.filtered_palestras = this.all_palestras.map(item => {
      let palestras = item.palestras.filter(aux => {
        return aux.date == data
      })
      return { ...item, palestras }
    })
  }

  clearFilter() {
    this.filtered_palestras = this.all_palestras
  }

  constructor() {
    super()

    this.all_palestras = Palestras_Cursos
    this.filtered_palestras = this.all_palestras
  }
}
